var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "asc__showPage" }, [
    _c("div", { staticClass: "asc__showPage-times" }, [
      _c("i", {
        staticClass: "fas fa-times-circle",
        on: {
          click: function($event) {
            return _vm.closeQuick()
          }
        }
      })
    ]),
    _vm._v(" "),
    _vm.rowData
      ? _c(
          "div",
          { staticClass: "asc__showPage-container" },
          [
            _c(
              "b-row",
              [
                _c("b-col", { attrs: { cols: "12" } }, [
                  _c(
                    "header",
                    [
                      _c("Breadcrumb", {
                        attrs: { title: _vm.rowData.Description1 }
                      })
                    ],
                    1
                  )
                ])
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "b-row",
              [
                _c("b-col", { attrs: { cols: "6" } }, [
                  _c("section", [
                    _c("span", [
                      _c("i", { staticClass: "fas fa-code" }),
                      _vm._v(" "),
                      _c("b", [
                        _vm._v(_vm._s(_vm.$t("insert.order.invoiceNo")) + ":")
                      ]),
                      _vm._v(" " + _vm._s(_vm.rowData.InvoiceNumber))
                    ])
                  ])
                ]),
                _vm._v(" "),
                _c(
                  "b-col",
                  { attrs: { cols: "6" } },
                  [
                    _c("b-card", { staticClass: "summary-card" }, [
                      _c("div", { staticClass: "summary-area" }, [
                        _c("span", { staticClass: "summary-title" }, [
                          _vm._v(_vm._s(_vm.$t("insert.order.netTotal")))
                        ]),
                        _vm._v(" "),
                        _c(
                          "span",
                          { staticClass: "summary-value text-muted" },
                          [_vm._v(": " + _vm._s(_vm.rowData.NetTotal))]
                        ),
                        _vm._v(" "),
                        _c("div", { staticClass: "clearfix" }),
                        _vm._v(" "),
                        _c("hr", { staticClass: "summary-hr" }),
                        _vm._v(" "),
                        _c("span", { staticClass: "summary-title" }, [
                          _vm._v(_vm._s(_vm.$t("insert.order.vatTotal")))
                        ]),
                        _vm._v(" "),
                        _c(
                          "span",
                          { staticClass: "summary-value text-muted" },
                          [_vm._v(": " + _vm._s(_vm.rowData.TotalVat))]
                        ),
                        _vm._v(" "),
                        _c("div", { staticClass: "clearfix" }),
                        _vm._v(" "),
                        _c("hr", { staticClass: "summary-hr" }),
                        _vm._v(" "),
                        _c("span", { staticClass: "summary-title" }, [
                          _vm._v(_vm._s(_vm.$t("insert.order.grossTotal")))
                        ]),
                        _vm._v(" "),
                        _c(
                          "span",
                          { staticClass: "summary-value text-muted" },
                          [_vm._v(": " + _vm._s(_vm.rowData.GrossTotal))]
                        ),
                        _vm._v(" "),
                        _c("div", { staticClass: "clearfix" }),
                        _vm._v(" "),
                        _c("hr", { staticClass: "summary-hr" })
                      ])
                    ])
                  ],
                  1
                )
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "b-tabs",
              [
                _c(
                  "b-tab",
                  {
                    attrs: {
                      title: _vm.$t("insert.order.enterInvoice"),
                      active: ""
                    }
                  },
                  [
                    _c(
                      "b-row",
                      { staticClass: "p-4" },
                      [
                        _c(
                          "b-card",
                          { staticClass: "col-md-6 col-12 asc__showPage-card" },
                          [
                            _c("div", {
                              domProps: {
                                innerHTML: _vm._s(
                                  _vm.getFormatDataByType(
                                    _vm.rowData.InvoiceKind,
                                    "object",
                                    "insert.order.invoiceKind"
                                  )
                                )
                              }
                            }),
                            _vm._v(" "),
                            _c("div", {
                              domProps: {
                                innerHTML: _vm._s(
                                  _vm.getFormatDataByType(
                                    _vm.rowData.DocumentDate,
                                    "date",
                                    "insert.order.documentDate"
                                  )
                                )
                              }
                            }),
                            _vm._v(" "),
                            _c("div", {
                              domProps: {
                                innerHTML: _vm._s(
                                  _vm.getFormatDataByType(
                                    _vm.rowData.DocumentTime,
                                    "text",
                                    "insert.order.documentTime"
                                  )
                                )
                              }
                            }),
                            _vm._v(" "),
                            _c("div", {
                              domProps: {
                                innerHTML: _vm._s(
                                  _vm.getFormatDataByType(
                                    _vm.rowData.Customer,
                                    "object",
                                    "insert.order.customer"
                                  )
                                )
                              }
                            }),
                            _vm._v(" "),
                            _c("div", {
                              domProps: {
                                innerHTML: _vm._s(
                                  _vm.getFormatDataByType(
                                    _vm.rowData.PriceList,
                                    "object",
                                    "insert.order.priceList"
                                  )
                                )
                              }
                            })
                          ]
                        ),
                        _vm._v(" "),
                        _c(
                          "b-card",
                          { staticClass: "col-md-6 col-12 asc__showPage-card" },
                          [
                            _c("div", {
                              domProps: {
                                innerHTML: _vm._s(
                                  _vm.getFormatDataByType(
                                    _vm.rowData.Description1,
                                    "text",
                                    "insert.order.description1"
                                  )
                                )
                              }
                            }),
                            _vm._v(" "),
                            _c("div", {
                              domProps: {
                                innerHTML: _vm._s(
                                  _vm.getFormatDataByType(
                                    _vm.rowData.DocumentNumber,
                                    "text",
                                    "insert.order.documentNumber"
                                  )
                                )
                              }
                            }),
                            _vm._v(" "),
                            _c("div", {
                              domProps: {
                                innerHTML: _vm._s(
                                  _vm.getFormatDataByType(
                                    _vm.rowData.PrintedDispatchNumber,
                                    "text",
                                    "insert.order.printedDispatchNumber"
                                  )
                                )
                              }
                            }),
                            _vm._v(" "),
                            _c("div", {
                              domProps: {
                                innerHTML: _vm._s(
                                  _vm.getFormatDataByType(
                                    _vm.rowData.Warehouse,
                                    "object",
                                    "insert.order.warehouse"
                                  )
                                )
                              }
                            }),
                            _vm._v(" "),
                            _c("div", {
                              domProps: {
                                innerHTML: _vm._s(
                                  _vm.getFormatDataByType(
                                    _vm.rowData.Currency,
                                    "object",
                                    "insert.order.currencyId"
                                  )
                                )
                              }
                            })
                          ]
                        )
                      ],
                      1
                    )
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "b-tab",
                  { attrs: { title: _vm.$t("insert.order.enterProducts") } },
                  [
                    _c(
                      "b-row",
                      [
                        _c(
                          "b-col",
                          { attrs: { cols: "12", md: "12" } },
                          [
                            _c(
                              "b-card",
                              { staticClass: "m-4 asc__showPage-card" },
                              [
                                _c("NextExportDetail", {
                                  attrs: {
                                    url:
                                      "VisionNextInvoice/api/PurchaseReturnInvoice/ExcelExportItems",
                                    "record-id": _vm.rowData.RecordId,
                                    "record-key": "invoiceId",
                                    "file-name": _vm.$t(
                                      "insert.order.enterProducts"
                                    )
                                  }
                                }),
                                _vm._v(" "),
                                _c(
                                  "b-table-simple",
                                  { attrs: { bordered: "", small: "" } },
                                  [
                                    _c(
                                      "b-thead",
                                      [
                                        _c("b-th", [
                                          _c("span", [
                                            _vm._v(
                                              _vm._s(
                                                _vm.$t("insert.order.product")
                                              )
                                            )
                                          ])
                                        ]),
                                        _vm._v(" "),
                                        _c("b-th", [
                                          _c("span", [
                                            _vm._v(
                                              _vm._s(
                                                _vm.$t(
                                                  "insert.order.productCode"
                                                )
                                              )
                                            )
                                          ])
                                        ]),
                                        _vm._v(" "),
                                        _c("b-th", [
                                          _c("span", [
                                            _vm._v(
                                              _vm._s(
                                                _vm.$t("insert.order.quantity")
                                              )
                                            )
                                          ])
                                        ]),
                                        _vm._v(" "),
                                        _c("b-th", [
                                          _c("span", [
                                            _vm._v(
                                              _vm._s(
                                                _vm.$t("insert.order.price")
                                              )
                                            )
                                          ])
                                        ]),
                                        _vm._v(" "),
                                        _c("b-th", [
                                          _c("span", [
                                            _vm._v(
                                              _vm._s(
                                                _vm.$t("insert.order.vatRate")
                                              )
                                            )
                                          ])
                                        ]),
                                        _vm._v(" "),
                                        _c("b-th", [
                                          _c("span", [
                                            _vm._v(
                                              _vm._s(
                                                _vm.$t("insert.order.netTotal")
                                              )
                                            )
                                          ])
                                        ]),
                                        _vm._v(" "),
                                        _c("b-th", [
                                          _c("span", [
                                            _vm._v(
                                              _vm._s(
                                                _vm.$t("insert.order.vatTotal")
                                              )
                                            )
                                          ])
                                        ]),
                                        _vm._v(" "),
                                        _c("b-th", [
                                          _c("span", [
                                            _vm._v(
                                              _vm._s(
                                                _vm.$t(
                                                  "insert.order.grossTotal"
                                                )
                                              )
                                            )
                                          ])
                                        ])
                                      ],
                                      1
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "b-tbody",
                                      _vm._l(_vm.rowData.InvoiceLines, function(
                                        o,
                                        i
                                      ) {
                                        return _c(
                                          "b-tr",
                                          { key: i },
                                          [
                                            _c("b-td", [
                                              _vm._v(_vm._s(o.Item.Label))
                                            ]),
                                            _vm._v(" "),
                                            _c("b-td", [
                                              _vm._v(_vm._s(o.Item.Code))
                                            ]),
                                            _vm._v(" "),
                                            _c("b-td", [
                                              _vm._v(_vm._s(o.Quantity))
                                            ]),
                                            _vm._v(" "),
                                            _c("b-td", [
                                              _vm._v(_vm._s(o.Price))
                                            ]),
                                            _vm._v(" "),
                                            _c("b-td", [
                                              _vm._v(_vm._s(o.VatRate))
                                            ]),
                                            _vm._v(" "),
                                            _c("b-td", [
                                              _vm._v(_vm._s(o.NetTotal))
                                            ]),
                                            _vm._v(" "),
                                            _c("b-td", [
                                              _vm._v(_vm._s(o.TotalVat))
                                            ]),
                                            _vm._v(" "),
                                            _c("b-td", [
                                              _vm._v(_vm._s(o.GrossTotal))
                                            ])
                                          ],
                                          1
                                        )
                                      }),
                                      1
                                    )
                                  ],
                                  1
                                )
                              ],
                              1
                            )
                          ],
                          1
                        )
                      ],
                      1
                    )
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "b-tab",
                  { attrs: { title: "Reference Documents" } },
                  [
                    _c(
                      "b-row",
                      [
                        _c(
                          "b-col",
                          { attrs: { cols: "12", md: "12" } },
                          [
                            _c(
                              "b-card",
                              { staticClass: "m-4 asc__showPage-card" },
                              [
                                _c(
                                  "b-table-simple",
                                  { attrs: { bordered: "", small: "" } },
                                  [
                                    _c(
                                      "b-thead",
                                      [
                                        _c("b-th", [
                                          _c("span", [
                                            _vm._v("Reference Invoice Number")
                                          ])
                                        ]),
                                        _vm._v(" "),
                                        _c("b-th", [
                                          _c("span", [
                                            _vm._v("Reference Document Date")
                                          ])
                                        ])
                                      ],
                                      1
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "b-tbody",
                                      _vm._l(
                                        _vm.rowData.InvoiceBillingReferences ||
                                          [],
                                        function(r, i) {
                                          return _c(
                                            "b-tr",
                                            { key: i },
                                            [
                                              _c("b-td", [
                                                _vm._v(
                                                  _vm._s(r.DocumentReference)
                                                )
                                              ]),
                                              _vm._v(" "),
                                              _c("b-td", [
                                                _vm._v(
                                                  _vm._s(
                                                    _vm.formatDateOnly(
                                                      r.DocumentReferenceDate
                                                    )
                                                  )
                                                )
                                              ])
                                            ],
                                            1
                                          )
                                        }
                                      ),
                                      1
                                    )
                                  ],
                                  1
                                )
                              ],
                              1
                            )
                          ],
                          1
                        )
                      ],
                      1
                    )
                  ],
                  1
                )
              ],
              1
            )
          ],
          1
        )
      : _vm._e()
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-63d490a2", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-63d490a2","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/PurchaseReturnInvoice/get.vue
// module id = null
// module chunks = 